<template>
  <nav class="navbar navbar-light navbar-expand-md nav_bar">
    <div class="flex-1">
      <button class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div id="navbarSupportedContent" class="collapse navbar-collapse justify-content-between">
        <!-- Left Side Of Navbar -->
        <div class="navbar-nav ml-md-3 nav_home">
          <h6 class="nav_home_title mb-1 font-weight-bold">{{ breadcrumbs.title ?? 'Unknown' }}</h6>
          <ul class="breadcrumbs">
            <li class="breadcrumb" v-for="(breadcrumb, index) in breadcrumbs.trail" :key="index">
              <inertia-link :href="breadcrumb.link ?? '#'"
                            class="breadcrumb_link"
                            :class="{'active': index === breadcrumbs.trail.length - 1}">
                {{ trans(breadcrumb.title) }}
              </inertia-link>
              <p class="m-0">
                <svg class="breadcrumb_icon" v-if="index < breadcrumbs.trail.length - 1">
                  <use xlink:href="#caret"></use>
                </svg>
              </p>
            </li>
          </ul>
        </div>

        <ul class="navbar-nav mr-md-3 nav_body">
          <li v-if="user.is_under_maintenance_mode" class="d-none d-lg-block nav-item mr-4">
            <span class="alert alert-warning py-2 font-weight-bold">Maintenance mode</span>
          </li>
          <li class="nav-item mr-4" v-html="trans('dashboard.logged_in_as_x', {name: user.name})"/>
          <li class="nav-item dropdown">
            <a href="#" class="d-block d-md-flex text-center nav-link p-0"
               id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img class="dropdown-toggle-image" :src="userPicture" :alt="trans('common.profile_photo')"/>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <inertia-link class="dropdown-item" :href="localeRoute('logout')" method="post" as="button">
                <i class="fa fa-fw text-left fa-btn fa-sign-out"></i> {{ trans('auth.logout') }}
              </inertia-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import {computed} from 'vue';
import {usePage, Link as InertiaLink} from '@inertiajs/vue3';
import {useLocales} from "@/composables/locales";

const localeRoute = useLocales().localeRoute

const user = computed(() => usePage().props.user)
const userPicture = computed(() => user.value.photo_url ?? '/images/05.jpg')
const breadcrumbs = computed(() => usePage().props.breadcrumbs ?? [])
</script>
